import {Component, ViewChild, EventEmitter} from '@angular/core';
import {MatPaginator, MatDialog, MatSort} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {generalService} from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import {Material} from '../../models/materiales';
import {DataSourceGrid,datosGrid} from '../../utils/sourceGrid.component';
import { FormGroup, FormBuilder, FormControl, Validators  } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'materiales-add-edit',
  styleUrls: [],
  templateUrl: 'materiales-add-edit.component.html',
  providers: [generalService]
})

export class MaterialesAddEditComponent {
  // --------- VARIABLES MATERIALES -------------//
  materialAgregar: FormGroup;
  public material:Material;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public isUpdate:boolean=false;
  public itemID:any; 

  private readonly SUCCESS_MSG = 'Se ha guardado exitosamente!';
  private readonly UPDATE_MS = 'Se actualizó exitosamente!';
  
  //----------- Listas (mat-select)-------------//
  public familiaCompraList:any=[];
  public subFamiliaCompraList:any=[];
  public productoCompraList:any=[];
  public unidadesContenedorList:any=[];
  public unidadMinCompraList:any=[];
  public contenedorCompraList:any=[];

  public familiaVentaList:any=[];
  public subFamiliaVentaList:any=[];
  public productoVentaList:any=[];
  public unidadesContVentaList:any=[];
  public unidadesMinVentaCtrl:any=[];
  public contenedorVentaCtrl:any=[];




  constructor(private _generalService: generalService, public dialog: MatDialog, public dataService: DataService/*, private sanitizer: DomSanitizer*/, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute) {
    this.material = new Material();
    this.itemID = this.route.snapshot.paramMap.get('id');    
  }

  async ngOnInit() {
    this.buildForm();
    await this.cargarPantalla();
    this.validateRoute();

  }

  buildForm(){
    this.materialAgregar = this.formBuilder.group({
        familiaCompraCtrl: this.formBuilder.control(null),
        subFamiliaCompraCtrl: this.formBuilder.control(null),
        productoCompraCtrl: this.formBuilder.control(null, [Validators.required]),
        unidadesContCompraCtrl: this.formBuilder.control(null),
        unidadMinCompraCtrl: this.formBuilder.control({value:null, disabled:true}),
        contenedorCompraCtrl:this.formBuilder.control({value:null, disabled:true}),

        familiaVentaCtrl:this.formBuilder.control(null),
        subFamiliaVentaCtrl:this.formBuilder.control(null),
        productoVentaCtrl: this.formBuilder.control(null, [Validators.required]),
        unidadesContVentaCtrl:this.formBuilder.control(null),
        unidadMinVentaCtrl:this.formBuilder.control({value:null, disabled:true}),
        contenedorVentaCtrl:this.formBuilder.control({value:null, disabled:true}),

        contenedorACompraConfigCtrl:this.formBuilder.control(null),
        contenedorAVentaConfigCtrl: this.formBuilder.control(null, [Validators.required]),
      });
  }

  cargarPantalla(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.requestGet("venta/cargarInformacionAgregarVenta?idUsuario=" + this.userData.USER_ID).subscribe(
        (result) => {
            var dataTemp: any = JSON.parse(result);
            // Tipo de venta
            //this.lstTipoVenta = dataTemp.Table1;
            // ----------------------   COMPRA   ------------------------ //
            // Familias
            this.familiaCompraList = dataTemp.Table2;
            this.material.lstFamiliaCompra = this.familiaCompraList;                        
            // Subfamilias
            this.subFamiliaCompraList = dataTemp.Table3;
            this.material.lstSubFamiliaCompra = this.subFamiliaCompraList;
            // Productos
            this.productoCompraList = dataTemp.Table4;
            this.material.lstProductoFiltradasCompra = this.productoCompraList;

            // ----------------------   VENTA   ------------------------ //
            // Familias
            this.familiaVentaList = dataTemp.Table2;
            this.material.lstFamiliaVenta = this.familiaVentaList;                        
            // Subfamilias
            this.subFamiliaVentaList = dataTemp.Table3;
            this.material.lstSubFamiliaVenta = this.subFamiliaVentaList;
            // Productos
            this.productoVentaList = dataTemp.Table4;
            this.material.lstProductoFiltradasVenta = this.productoVentaList; 
            //this.datosGeneralesSAE.showSpinnerLoading = false;
            resolve();
        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
            reject();
        }
    );

    });
  }

  validateRoute() {
    if (this.itemID === 'N') {
      this.isUpdate = false;      
    } else if (parseInt(this.itemID)) {
      this.isUpdate = true;
      this.consultItem(this.itemID);
    } else {
      this.router.navigate(['material/N']);
    }
  }

  consultItem(itemID:any){
    this._generalService.metodoCallParams(itemID, 'material/consultaMaterials/')
        .subscribe(items => {
          var result = JSON.parse(items);
          if (result.length > 0) {
            this.material.ITEM_ID_COMPRA = result[0].ITEM_TO_BUY;
            this.material.ITEM_FAMILY_ID_COMPRA = result[0].ITEM_FAMILY_ID_BUY;
            this.material.ITEM_SUBFAMILY_ID_COMPRA = result[0].ITEM_SUBFAMILY_ID_BUY;
            this.material.ITEM_ID_VENTA = result[0].ITEM_TO_SELL;
            this.material.ITEM_FAMILY_ID_VENTA = result[0].ITEM_FAMILY_ID_SELL;
            this.material.ITEM_SUBFAMILY_ID_VENTA = result[0].ITEM_SUBFAMILY_ID_SELL;
            this.material.contenedorAVentaConfig = result[0].QUANTITY;
            this.material.itemID = result[0].ITEM_CONVERT_ID;

            this.datosProductosCompra(this.material);
            this.datosProductosVenta(this.material);
          } 
        }, error => {
          // Custom error handler
        });
  }

  cambiarFamiliaSubfamilia(material: Material, opcion: number) {
    if (opcion == 1) {
        material.ITEM_SUBFAMILY_ID_COMPRA = undefined;
        material.ITEM_ID_COMPRA = undefined;

        material.lstSubFamiliaCompra = this.subFamiliaCompraList.filter((obj) => {
            return obj.ITEM_FAMILY_ID === material.ITEM_FAMILY_ID_COMPRA; //filtra en base al family_id
        });
        material.lstProductCompra = this.productoCompraList.filter((obj) => {
            return obj.ITEM_FAMILY_ID === material.ITEM_FAMILY_ID_COMPRA
        });
    } 

    if (opcion == 2) {
      material.ITEM_ID_COMPRA = undefined;
      material.lstProductCompra = this.productoCompraList.filter((obj) => {
          return obj.ITEM_SUBFAMILY_ID === material.ITEM_SUBFAMILY_ID_COMPRA;
      });
    }
    material.lstProductoFiltradasCompra = material.lstProductCompra;
    material.searchProductCompra = undefined;
    material.UNITS_PER_CONTAINER_COMPRA = undefined;
    material.MINIMUM_UNIT_NAME_COMPRA = undefined;
    material.CONTAINER_NAME_COMPRA = undefined;
  
    //console.log('OBJ',material);
  }
  //PARA LA PARTE DE VENTA
  cambiarFamiliaSubfamiliaVenta(material: Material, opcion: number) {
    if (opcion == 1) {
        material.ITEM_SUBFAMILY_ID_VENTA = undefined;
        material.ITEM_ID_VENTA = undefined;

        material.lstSubFamiliaVenta = this.subFamiliaVentaList.filter((obj) => {
            return obj.ITEM_FAMILY_ID === material.ITEM_FAMILY_ID_VENTA; //filtra en base al family_id
        });
        material.lstProductVenta = this.productoVentaList.filter((obj) => {
            return obj.ITEM_FAMILY_ID === material.ITEM_FAMILY_ID_VENTA
        });
    } 

    if (opcion == 2) {
      material.ITEM_ID_VENTA = undefined;
      material.lstProductVenta = this.productoVentaList.filter((obj) => {
          return obj.ITEM_SUBFAMILY_ID === material.ITEM_SUBFAMILY_ID_VENTA;
      });
    }
    material.lstProductoFiltradasVenta = material.lstProductVenta;
    material.searchProductVenta = undefined;
    material.UNITS_PER_CONTAINER_VENTA = undefined;
    material.MINIMUM_UNIT_NAME_VENTA = undefined;
    material.CONTAINER_NAME_VENTA = undefined;
  
    //console.log('OBJ',material);
  }

  datosProductosCompra(material: Material) {
    const productoElegido = this.productoCompraList.filter((obj) => {
        return obj.ITEM_ID === material.ITEM_ID_COMPRA;
    });

    material.UNITS_PER_CONTAINER_COMPRA = productoElegido[0].UNITS_PER_CONTAINER;
    material.MINIMUM_UNIT_NAME_COMPRA = productoElegido[0].MINIMUM_UNIT_NAME;
    material.CONTAINER_NAME_COMPRA = productoElegido[0].CONTAINER_NAME
  }

  datosProductosVenta(material: Material) {
    const productoElegido = this.productoVentaList.filter((obj) => {
        return obj.ITEM_ID === material.ITEM_ID_VENTA;
    });

    material.UNITS_PER_CONTAINER_VENTA = productoElegido[0].UNITS_PER_CONTAINER;
    material.MINIMUM_UNIT_NAME_VENTA = productoElegido[0].MINIMUM_UNIT_NAME;
    material.CONTAINER_NAME_VENTA = productoElegido[0].CONTAINER_NAME
  }


  filtrarProductosCompra(material: Material) {
    let arr: any[];
    if (material.searchProductCompra) {
        arr = material.lstProductoFiltradasCompra.filter((obj) => {
            return obj.NAME.indexOf(material.searchProductCompra) > -1 || ((obj.SKU) ? obj.SKU : '').indexOf(material.searchProductCompra) > -1 || ((obj.BARCODE) ? obj.BARCODE : '').indexOf(material.searchProductCompra) > -1;
        });
    } 
    else {
        arr = material.lstProductCompra;
    }
    material.lstProductoFiltradasCompra = arr;
  }

  filtrarProductosVenta(material: Material) {
    let arr: any[];
    if (material.searchProductVenta) {
        arr = material.lstProductoFiltradasVenta.filter((obj) => {
            return obj.NAME.indexOf(material.searchProductVenta) > -1 || ((obj.SKU) ? obj.SKU : '').indexOf(material.searchProductVenta) > -1 || ((obj.BARCODE) ? obj.BARCODE : '').indexOf(material.searchProductVenta) > -1;
        });
    } 
    else {
        arr = material.lstProductVenta;
    }
    material.lstProductoFiltradasVenta = arr;
  }

  agregar() {
      let tipo = 'agregar';
      let metodo = 'material/insertarConversionMaterial/';
      
      var params = {
        ITEM_CONVERT_ID:null, 
        ITEM_TO_BUY : this.material.ITEM_ID_COMPRA,
        ITEM_FAMILY_ID_BUY: this.material.ITEM_FAMILY_ID_COMPRA,
        ITEM_SUBFAMILY_ID_BUY: this.material.ITEM_SUBFAMILY_ID_COMPRA, 
        ITEM_TO_SELL: this.material.ITEM_ID_VENTA, 
        ITEM_FAMILY_ID_SELL: this.material.ITEM_FAMILY_ID_VENTA,
        ITEM_SUBFAMILY_ID_SELL: this.material.ITEM_SUBFAMILY_ID_VENTA, 
        QUANTITY: this.material.contenedorAVentaConfig,
      };

      this._generalService.metodoCallParamsPutPost(tipo, params, metodo).subscribe(
          (result) => {
            if (result == '') {
              this._generalService.toastCall(this.SUCCESS_MSG);
            } else {
              this.dataService.guardado = true;
            }
          },
          (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
          }
      );
   // }
  }

  update() {
    if(this.isUpdate){
      //this.product.loacs = sessionStorage.getItem("acslo");
      var params = {
        ITEM_CONVERT_ID:this.material.itemID, 
        ITEM_TO_BUY: this.material.ITEM_ID_COMPRA,
        ITEM_FAMILY_ID_BUY: this.material.ITEM_FAMILY_ID_COMPRA,
        ITEM_SUBFAMILY_ID_BUY: this.material.ITEM_SUBFAMILY_ID_COMPRA, 
        ITEM_TO_SELL: this.material.ITEM_ID_VENTA, 
        ITEM_FAMILY_ID_SELL: this.material.ITEM_FAMILY_ID_VENTA,
        ITEM_SUBFAMILY_ID_SELL: this.material.ITEM_SUBFAMILY_ID_VENTA, 
        QUANTITY: this.material.contenedorAVentaConfig,
      };
      this._generalService.metodoCallParams(params, 'material/updateConversionMaterial/')
          .subscribe(result => {
            if (result == '') {
              this._generalService.toastCall(this.UPDATE_MS)
            } else {
              this.dataService.guardado = true;
            }
          }, error => {
            // Custom error handler
            const errorMsj =  error as any;
            console.log(errorMsj);
          });
    }
  }

  regresar(){
    this.router.navigate(['app/materiales']);
  }


}//fin de export class




// WEBPACK FOOTER //
// ./src/app/materiales/add-edit/materiales-add-edit.component.ts